export const UPDATE_VALUE = 'fulcrum/containers/Form/Slider/UPDATE_VALUE'
